export default {
  download(pdfUrl, fileName) {
    const fileUrl = pdfUrl; // 文件的URL地址
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    link.click();
  },

  // download2(data, fileName, mineType) {
  //   // 创建 blob
  //   // let blob = new Blob([data], { type: 'application/msword' });
  //   let blob = new Blob([data]);
  //   // 创建 href 超链接，点击进行下载
  //   window.URL = window.URL || window.webkitURL;
  //   let href = URL.createObjectURL(blob);
  //   let downA = document.createElement("a");
  //   downA.href = href;
  //   downA.download = fileName;
  //   downA.click();
  //   // 销毁超连接
  //   window.URL.revokeObjectURL(href);
  // },

  // download3(data, fileName) {
  //   const url = window.URL.createObjectURL(new Blob([data]));
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', fileName);
  //   document.body.appendChild(link);
  //   link.click();
  // },
}
